import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { configService } from './configService';
import logger from '../utils/logger';

const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights | null = null;

async function initializeAppInsights(): Promise<void> {
  const config = configService.get();
  const connectionString = config['frontend:applicationInsightsConnectionString'];

  if (!connectionString) {
    logger.warn('Application Insights not configured - missing connection string');
    return;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      correlationHeaderExcludedDomains: ['*.queue.core.windows.net'],
      disableFetchTracking: false,
      enableAjaxPerfTracking: true,
      maxAjaxCallsPerView: 500,
      extensions: [reactPlugin],
    },
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();

  logger.debug('Application Insights initialized from runtime config');
}

export { appInsights, reactPlugin, initializeAppInsights };
